import { ScreenshotsAuditRules } from './audit-rules';

export enum ColorFilter {
  none = 'none',
  achromatomaly = 'achromatomaly',
  achromatopsia = 'achromatopsia',
  deuteranomaly = 'deuteranomaly',
  deuteranopia = 'deuteranopia',
  protanomaly = 'protanomaly',
  protanopia = 'protanopia',
  tritanomaly = 'tritanomaly',
  tritanopia = 'tritanopia',
  grayscale = 'grayscale',
  grayscale_back = 'grayscale_back',
  invert_grayscale = 'invert_grayscale',
  high_contrast = 'high_contrast',
  high_contrast_back = 'high_contrast_back',
  invert = 'invert',
  invert_back = 'invert_back',
  yellow_on_black = 'yellow_on_black',
  yellow_on_black_back = 'yellow_on_black_back',
}

export const ScreenshotRuleToColorFilter: Record<keyof typeof ScreenshotsAuditRules, ColorFilter> = {
  [ScreenshotsAuditRules.screenshot_desktop_grayscale]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_achromatomaly]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_achromatopsia]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_deuteranomaly]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_deuteranopia]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_protanomaly]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_protanopia]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_tritanomaly]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_tritanopia]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_invert_grayscale]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_invert]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_high_contrast]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_yellow_on_black]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_mobile_full_size]: ColorFilter.none,
  [ScreenshotsAuditRules.screenshot_desktop_hd_full_size]: ColorFilter.none,

  [ScreenshotsAuditRules.screenshot_grayscale]: ColorFilter.grayscale,
  [ScreenshotsAuditRules.screenshot_achromatomaly]: ColorFilter.achromatomaly,
  [ScreenshotsAuditRules.screenshot_achromatopsia]: ColorFilter.achromatopsia,
  [ScreenshotsAuditRules.screenshot_deuteranomaly]: ColorFilter.deuteranomaly,
  [ScreenshotsAuditRules.screenshot_deuteranopia]: ColorFilter.deuteranopia,
  [ScreenshotsAuditRules.screenshot_protanomaly]: ColorFilter.protanomaly,
  [ScreenshotsAuditRules.screenshot_protanopia]: ColorFilter.protanopia,
  [ScreenshotsAuditRules.screenshot_tritanomaly]: ColorFilter.tritanomaly,
  [ScreenshotsAuditRules.screenshot_tritanopia]: ColorFilter.tritanopia,
  [ScreenshotsAuditRules.screenshot_invert_grayscale]: ColorFilter.invert_grayscale,
  [ScreenshotsAuditRules.screenshot_invert]: ColorFilter.invert,
  [ScreenshotsAuditRules.screenshot_high_contrast]: ColorFilter.high_contrast,
  [ScreenshotsAuditRules.screenshot_yellow_on_black]: ColorFilter.yellow_on_black,
  [ScreenshotsAuditRules.screenshot_full_size]: ColorFilter.none,
};
